// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jg-1";
export var messageSideRight = "_jg-2";
export var subscribeToBackInStockBubbleContainer = "_jg-0";